import { ReactElement } from 'react'
import { useWatch } from 'react-hook-form'
import { LoadingButton } from '@mui/lab'
import { Tooltip } from '@mui/material'
import { PlanViewPlanChoice } from '../../constants'

interface Props {
  storeys: readonly string[]
  planType: PlanViewPlanChoice
  isGenerating: boolean
  /** The project has (at least partially) valid results, which the plan is built from. */
  hasResults: boolean
  /** Plan settings changes not saved yet: the export would still use the old settings. */
  isPlanSettingsSavePending?: boolean
}

/**
 * "Plan generieren": submits the plan creation form (see `PlanViewCreateSection`). Disabled
 * without valid results, without a plan name, and while plan settings changes are still being
 * saved.
 */
const PlanExportButton = ({
  storeys,
  planType,
  isGenerating,
  hasResults,
  isPlanSettingsSavePending = false,
}: Props): ReactElement => {
  const name: string = useWatch({ name: 'name' }) ?? ''
  const hasName = !!name.trim()

  return (
    <Tooltip
      title={
        !hasResults
          ? 'Keine gültigen Ergebnisse vorhanden'
          : !hasName
          ? 'Bitte einen Plannamen eingeben'
          : isPlanSettingsSavePending
          ? 'Einstellungen werden noch gespeichert'
          : ''
      }
    >
      <span>
        <LoadingButton
          type="submit"
          variant="contained"
          size="small"
          loading={isGenerating}
          disabled={
            (planType !== 'loadPlan' && !storeys.length) ||
            !hasResults ||
            !hasName ||
            isPlanSettingsSavePending ||
            isGenerating
          }
          data-cy="plan-view-export-button"
        >
          Plan generieren
        </LoadingButton>
      </span>
    </Tooltip>
  )
}

export default PlanExportButton
